import type { StaticCataloguesCatalogueDto } from '@ori/static-api-client-react';

export const formatValidity = (
  catalogueId: string,
  catalogues: StaticCataloguesCatalogueDto[],
  formatValidityDate: (date: Date) => string,
) => {
  const catalogue = catalogues.find((e) => e.catalogueId.toString() === catalogueId);

  if (!catalogue?.valid || !(catalogue.valid.from instanceof Date) || !(catalogue.valid.to instanceof Date)) {
    return null;
  }

  const from = formatValidityDate(catalogue.valid.from);
  const to = formatValidityDate(catalogue.valid.to);

  return `${from} - ${to}`;
};
